export default __webpack_public_path__ + "static/media/pantry2-after2-480w.7382a783.png";